import './HeaderForActivationPage.css';
import React, { useRef } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Recaptcha from '../Login/components/Recaptcha';
import { loaderToggle } from '../../utils/setUserCookie';
const HeaderForActivationPage = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const [isRegistrationSuccess, setIsRegistrationSuccess] = React.useState(true);
  const [userId, setUserId] = React.useState('');
  const [formResponseError, setFormResponseError] = React.useState('');
  const [recaptchaError, setRecaptchaError] = React.useState('');
  const [disableSubmit, setDisableSubmit] = React.useState(false);
  const titleSuccess = get(fields, 'data.item.titleSuccess.jss.value') || '';
  const introTextSuccess = get(fields, 'data.item.introTextSuccess.jss.value') || '';
  const titleFailed = get(fields, 'data.item.titleFailed.jss.value') || '';
  const introTextFailed = get(fields, 'data.item.introTextFailed.jss.value') || '';
  const loginPageLink = get(fields, 'data.item.loginPageLink.jss.value.href') || '';
  const thankYouPageLink = get(fields, 'data.item.thankYouPageLink.jss.value.href') || '';
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const SubmitBtnText = mapDictionary.get('SubmitButtonText');
  const RedirectBtnText = mapDictionary.get('SuccessBtnText') || '';
  const recaptchErrorMessage = mapDictionary.get('FieldErrorRequiredRecaptcha');
  let formPostErrors = [];
  const generalErrorCode = 'Failed';
  let allErrors = [];
  const recaptchaRef = useRef(null);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const describeTextRef = React.useRef(null);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', '#000');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const styleThemeHexColor = BackgroundColorHex ? {
    '--header-for-activation-page-background-color': BackgroundColorHex,
    '--header-for-activation-page-active-color': ActiveColorHex,
    '--header-for-activation-page-color': ColorHex
  } : {
    '--header-for-activation-page-background-color': selectedPrimaryColor,
    '--header-for-activation-page-active-color': selectedPrimaryActiveColor,
    '--header-for-activation-page-color': getColorByTheme(selectedPrimaryColor)
  };
  formPostErrors.push({
    errorCode: generalErrorCode,
    message: mapDictionary.get('MessageConfirmationApiFail')
  });
  React.useEffect(() => {
    if (canUseDOM) {
      const url = new URL(window.location.href);
      let result = url.searchParams.get('result');
      let errors = url.searchParams.get('errors');
      if (errors && result) {
        if (errors.includes('verified_already')) {
          setIsRegistrationSuccess(true);
        } else if (result.toLocaleLowerCase() !== 'true') {
          setIsRegistrationSuccess(false);
          setUserId(errors.replace('InvalidToken,', ''));
        }
      }
    }
  }, []);
  React.useEffect(() => {
    if (describeTextRef && describeTextRef.current) {
      describeTextRef.current.innerHTML = isRegistrationSuccess ? introTextSuccess : introTextFailed;
    }
  }, [isRegistrationSuccess]);
  if (!fields) {
    console.warn('HeaderForActivationPage component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[HeaderForActivationPage component is empty: please provide datasource]");
    }
    return null;
  }
  const resendLink = async () => {
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    let statusCode = 0;
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    let formdata = new FormData();
    formdata.append('g-recaptcha-response', recaptchaToken);
    formdata.append('clientId', clientId);
    formdata.append('userId', userId);
    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: formdata
    };
    await fetch(`${identityGlobal}/api/account/ResendUserConfirmation`, requestOptions).then(response => {
      loaderToggle(false, setDisableSubmit);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess) {
          if (canUseDOM) {
            if (thankYouPageLink) {
              window.location.href = thankYouPageLink;
            } else {
              console.log('please fill in thankYouPageLink');
            }
          }
        } else if (!responseObj.isSuccess) {
          if (responseObj.errors && responseObj.errors.length) {
            throw Error(responseObj.errors[0].code);
          }
        }
      } else {
        throw Error(generalErrorCode);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      if (statusCode === 0) {
        showResponseError(generalErrorCode);
      } else {
        showResponseError(error.message);
      }
    });
  };

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    for (const fieldObj of allErrors) {
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };

  // Form submit handler
  const formSubmit = event => {
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      resendLink();
    }
    event.preventDefault();
  };
  const showResponseError = errorCode => {
    const errorObject = formPostErrors.find(errorItem => {
      return errorItem.errorCode === errorCode;
    });
    if (errorObject) {
      setFormResponseError(errorObject.message);
    } else {
      setFormResponseError(formPostErrors[0].message);
    }
  };
  const redirectToLogin = () => {
    if (canUseDOM) {
      window.location.href = loginPageLink;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h2 c-title__text"
  }, isRegistrationSuccess ? titleSuccess : titleFailed), /*#__PURE__*/React.createElement("p", {
    className: "p header__content",
    ref: describeTextRef
  }), isRegistrationSuccess && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__submit-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "button",
    disabled: loginPageLink ? false : true,
    onClick: redirectToLogin
  }, RedirectBtnText)))), !isRegistrationSuccess && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__submit-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "button",
    disabled: disableSubmit,
    onClick: formSubmit
  }, SubmitBtnText)))), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c18bm3su";
const rtlStyles = "r1arkr39";
const ltrStyles = "l1vdir0n";
export default HeaderForActivationPage;